import { apiClient } from './client';

export const registrationApi = {
  getAll:     (params)       => apiClient.get('/registrations', { params }),
  getById:    (id)           => apiClient.get(`/registrations/${id}`),
  getByEvent: (eventId)      => apiClient.get(`/registrations/event/${eventId}`),
  getByChild: (childId)      => apiClient.get(`/registrations/child/${childId}`),
  register:   (data)         => apiClient.post('/registrations', data),
  delete:     (id)           => apiClient.delete(`/registrations/${id}`),
  bulkImport: (formData)     => apiClient.post('/registrations/bulk-import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  bulkRegister: (data)       => apiClient.post('/registrations/bulk', data),
  bulkDelete:   (ids)        => apiClient.post('/registrations/bulk-delete', { ids }),
};
